// スネークケースからキャメルケースに変換（文字列）.
export const toCamelCase = (str: string, upperCamel = false): string => {
  return str
    .split('_')
    .map(function (word, index) {
      if (!upperCamel && index === 0) {
        return word.toLowerCase()
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join('')
}

// キャメルケースからスネークケースに変換（文字列）.
export const toSnakeCase = (str: string): string => {
  return str
    .split(/(?=[A-Z])/)
    .join('_')
    .toLowerCase()
}
